import { PapiDeviation, PapiEditorText } from '@wix/da-papi-types';
import i18next from 'i18next';
import { toLightweightDeviation } from '@wix/da-editor-tiptap/pkg/extensions/utils/toLightweightDeviation';

export function createWithDeviation({
  extended, // extended data is prone to circulars due to related content, and we dont need it here
  ...deviation
}: PapiDeviation): PapiEditorText {
  return {
    excerpt: '',
    html: {
      type: 'tiptap',
      markup: JSON.stringify({
        version: '1',
        document: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              attrs: { indentType: null, indentation: '', textAlign: 'left' },
              content: [{ type: 'text', text: i18next.t('editor.shareToPost.text') }],
            },
            {
              type: 'da-deviation',
              attrs: {
                deviation: toLightweightDeviation(deviation),
                alignment: 'center',
                link: null,
                width: null,
              },
            },
          ],
        },
      }),
      features: '[]',
    },
  };
}

export function createWithDeviationAndText(
  {
    extended, // extended data is prone to circulars due to related content, and we dont need it here
    ...deviation
  }: PapiDeviation,
  text = i18next.t('editor.shareToPost.text')
): PapiEditorText {
  return {
    excerpt: '',
    html: {
      type: 'tiptap',
      markup: JSON.stringify({
        version: '1',
        document: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              attrs: { indentType: null, indentation: '', textAlign: 'left' },
              content: [{ type: 'text', text }],
            },
            {
              type: 'da-deviation',
              attrs: {
                deviation: toLightweightDeviation(deviation),
                alignment: 'center',
                link: null,
                width: null,
              },
            },
          ],
        },
      }),
      features: '[]',
    },
  };
}
